"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertSalesforce = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../forms/utils/endpoints");
const postFunctions_1 = require("../services/postFunctions");
const endpoints = new endpoints_1.default;
const postFunctions = new postFunctions_1.default(endpoints.baseURL, endpoints.registerEnv);
const regexEmail = new RegExp(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@(?!gmail\.com)(?!hotmail\.com)(?!yahoo\.com)(?!wp\.pl)(?!seznam\.cz)(?!o2\.pl)(?!icloud\.com)(?!inbox\.lv)(?!abv\.bg)(?!freemail\.hu)(?!outlook\.com)(?!interia\.pl)(?!onet\.pl)(?!live\.com)([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(plus|aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);
const upsertSalesforce = (formData, smClient = '') => {
    const email = formData.querySelector('#sm_email');
    if (regexEmail.test(email.value)) {
        axios_1.default.post(endpoints.salesforce, new FormData(formData))
            .then((response) => {
            console.log(response.data);
        })
            .catch((error) => {
            console.log(error.response);
        });
    }
};
exports.upsertSalesforce = upsertSalesforce;
